export const getJWToken = () =>
{
    return localStorage.getItem("jwtoken");
};
